/**
 * Marketing-site analytics events.
 *
 * Pushes a named event onto Google Tag Manager's `dataLayer`. GTM listens
 * for it with a "Custom Event" trigger and forwards it to GA4 (or an ads
 * pixel) — see `components/landing/GoogleTagManager.jsx`. Nothing here
 * talks to Google directly, so it is a harmless no-op when GTM is absent
 * (tenant hosts, the logged-in app, `NEXT_PUBLIC_GTM_ID` unset).
 *
 * Fire events for things that already happened and that the business cares
 * about — a lead saved on the server, not a button click. Click triggers
 * are configured inside GTM without code.
 *
 * Event names in use (keep this list current; GTM triggers match on them):
 *   lead_submitted  { request_type: 'demo' | 'enquiry' }
 */
type EventParams = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export function trackEvent(event: string, params: EventParams = {}): void {
  if (typeof window === "undefined") return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch {
    // Analytics must never break the page.
  }
}
